module.exports = __webpack_public_path__ + "static/media/invoice-reports.8088ffef.svg";